import React from 'react';
import styled from 'styled-components/macro';
import { FlexColumn, FlexRow } from '../basic/Flex';
import { Body2, H4 } from '../common';
import Pictogram, { PictogramName } from '../common/Pictogram';
import { ThemeColor, themeColors } from '../../theme/theme';

export type SmallLiftupProps = {
  title: string;
  subTitle?: string;
  heading?: string;
  pictogram?: PictogramName;
  background?: ThemeColor;
  mainButton?: React.ReactElement;
};

const MainContainer = styled(FlexColumn)`
  border: 2px solid ${themeColors.m2White};
  border-radius: 35px;
  overflow: hidden;
  min-width: 300px;
  min-height: 330px;
  background: ${themeColors.white};
`;

const TopContainer = styled(FlexColumn)<{ background: string }>`
  background: ${(props) => props.background};
  min-height: 180px;
  justify-content: center;
  align-items: center;
`;

const BottomContainer = styled(FlexColumn)`
  padding: 16px;
`;

const SmallLiftup: React.FC<SmallLiftupProps> = ({
  title,
  subTitle,
  heading,
  pictogram,
  background = 'apila',
  mainButton,
}) => {
  return (
    <MainContainer>
      <TopContainer background={themeColors[background]}>
        {pictogram ? <Pictogram name={pictogram} /> : <></>}
      </TopContainer>
      <BottomContainer>
        <Body2>{heading}</Body2>
        <H4>{title}</H4>
        <Body2 margin="4px">{subTitle}</Body2>
        {mainButton && <FlexRow padding="16px 0 4px">{mainButton}</FlexRow>}
      </BottomContainer>
    </MainContainer>
  );
};

export default SmallLiftup;
